import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ModelsGroupsLayer from "../components/ModelsGroupsLayer";

const GroupPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Models & Groups'>
        <ModelsGroupsLayer />
      </MasterLayout>
    </>
  );
};

export default GroupPage;
